/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetUserCountResponseAdmin } from '../models/GetUserCountResponseAdmin';
import type { GetUserRolesAdmin } from '../models/GetUserRolesAdmin';
import type { GetUserRolesResponseAdmin } from '../models/GetUserRolesResponseAdmin';
import type { GetUsersByIdsResponseAdmin } from '../models/GetUsersByIdsResponseAdmin';
import type { JwtToken } from '../models/JwtToken';
import type { Pagination1OfUserDto } from '../models/Pagination1OfUserDto';
import type { PostLogoutRequest } from '../models/PostLogoutRequest';
import type { PostUserAdminRequest } from '../models/PostUserAdminRequest';
import type { UpdateUserProfileRequest } from '../models/UpdateUserProfileRequest';
import type { UpdateUserRolesRequestAdmin } from '../models/UpdateUserRolesRequestAdmin';
import type { UserDto } from '../models/UserDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UsersService {
    /**
     * @returns UserDto OK
     * @throws ApiError
     */
    public static postUserAdmin({
        requestBody,
    }: {
        requestBody?: PostUserAdminRequest,
    }): CancelablePromise<UserDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/users',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns Pagination1OfUserDto OK
     * @throws ApiError
     */
    public static getUsersAdmin({
        searchWord,
        id,
        regionId,
        baseRoleId,
        onlyHasNoZohoCrmId,
        birthDateFrom,
        birthDateTo,
        createdAtFrom,
        createdAtTo,
        page,
        limit,
        sortField,
        sortDescending,
    }: {
        searchWord?: string,
        id?: string,
        regionId?: number,
        baseRoleId?: number,
        onlyHasNoZohoCrmId?: boolean,
        birthDateFrom?: string,
        birthDateTo?: string,
        createdAtFrom?: string,
        createdAtTo?: string,
        page?: number,
        limit?: number,
        sortField?: string,
        sortDescending?: boolean,
    }): CancelablePromise<Pagination1OfUserDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/users',
            query: {
                'searchWord': searchWord,
                'id': id,
                'regionId': regionId,
                'baseRoleId': baseRoleId,
                'onlyHasNoZohoCrmId': onlyHasNoZohoCrmId,
                'birthDateFrom': birthDateFrom,
                'birthDateTo': birthDateTo,
                'createdAtFrom': createdAtFrom,
                'createdAtTo': createdAtTo,
                'page': page,
                'limit': limit,
                'sortField': sortField,
                'sortDescending': sortDescending,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns UserDto OK
     * @throws ApiError
     */
    public static getUserAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<UserDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/users/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetUserRolesResponseAdmin OK
     * @throws ApiError
     */
    public static getUserRolesAdmin({
        userId,
    }: {
        userId: string,
    }): CancelablePromise<GetUserRolesResponseAdmin> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/users/{userId}/roles',
            path: {
                'userId': userId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetUsersByIdsResponseAdmin OK
     * @throws ApiError
     */
    public static getUserByIdsAdmin({
        ids,
    }: {
        ids?: Array<string>,
    }): CancelablePromise<GetUsersByIdsResponseAdmin> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/users/by-ids',
            query: {
                'ids': ids,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns UserDto OK
     * @throws ApiError
     */
    public static getCurrentUserAdmin(): CancelablePromise<UserDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/users/current',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static putCurrentUserAdmin({
        requestBody,
    }: {
        requestBody?: UpdateUserProfileRequest,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/users/current',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetUserRolesAdmin OK
     * @throws ApiError
     */
    public static getCurrentUserRolesAdmin(): CancelablePromise<GetUserRolesAdmin> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/users/current/roles',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetUserCountResponseAdmin OK
     * @throws ApiError
     */
    public static getUsersCountAdmin({
        searchWord,
        id,
        regionId,
        baseRoleId,
        onlyHasNoZohoCrmId,
        birthDateFrom,
        birthDateTo,
        createdAtFrom,
        createdAtTo,
        page,
        limit,
        sortField,
        sortDescending,
    }: {
        searchWord?: string,
        id?: string,
        regionId?: number,
        baseRoleId?: number,
        onlyHasNoZohoCrmId?: boolean,
        birthDateFrom?: string,
        birthDateTo?: string,
        createdAtFrom?: string,
        createdAtTo?: string,
        page?: number,
        limit?: number,
        sortField?: string,
        sortDescending?: boolean,
    }): CancelablePromise<GetUserCountResponseAdmin> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/users/count',
            query: {
                'searchWord': searchWord,
                'id': id,
                'regionId': regionId,
                'baseRoleId': baseRoleId,
                'onlyHasNoZohoCrmId': onlyHasNoZohoCrmId,
                'birthDateFrom': birthDateFrom,
                'birthDateTo': birthDateTo,
                'createdAtFrom': createdAtFrom,
                'createdAtTo': createdAtTo,
                'page': page,
                'limit': limit,
                'sortField': sortField,
                'sortDescending': sortDescending,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static putUserAdmin({
        userId,
        requestBody,
    }: {
        userId: string,
        requestBody?: UpdateUserProfileRequest,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/users/{userId}/update',
            path: {
                'userId': userId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static putUserBaseRolesAdmin({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: UpdateUserRolesRequestAdmin,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/users/{id}/base-roles',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static deleteUserAdmin({
        userId,
    }: {
        userId?: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/users/delete',
            query: {
                'userId': userId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns JwtToken OK
     * @throws ApiError
     */
    public static postLogoutAdmin({
        requestBody,
    }: {
        requestBody?: PostLogoutRequest,
    }): CancelablePromise<JwtToken> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/users/logout',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static postZohoSubmissionAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/users/{id}/zoho-submission',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
